import React, { useEffect } from 'react';
import * as ReactDOM from 'react-dom';

export const Modal = props => {
    const showHideClassName = props.show ? 'modal-show' : 'modal-hide';

    return (
        <div className={`modal-container ${showHideClassName}`}>
            <div className="pixel-modal-x" style={{ position: 'relative' }}>
                <div className="pixel-modal-body">
                    {props.children}{props.content}
                </div>
            </div>
        </div>
    );
};

const Modal2Component = React.memo(function Modal2Component(props) {
  const { show, modalTitle, children, content, handleClose, imageUrl, titleAction, panelClassName } = props;
  const handleCloseRef = React.useRef(handleClose);
  handleCloseRef.current = handleClose;

    useEffect(() => {
        if (show && typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
            const handleEsc = (e) => { if (e.key === 'Escape') handleCloseRef.current?.(); };
            document.addEventListener('keydown', handleEsc);
            return () => document.removeEventListener('keydown', handleEsc);
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [show]);

    if (!show) return null;

    const onClose = handleClose || (() => console.warn('No `handleClose` prop provided to Modal2'));

    const modal = (
        <div className="pixel-modal-backdrop" onClick={onClose}>
            <div
                className={`pixel-modal-x${panelClassName ? ' ' + panelClassName : ''}`}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal
                aria-label={modalTitle}
            >
                <div className="pixel-modal-header">
                    <h3 className="pixel-modal-title">{modalTitle}</h3>
                    <div className="pixel-modal-header-actions">
                        {titleAction}
                        <button
                            type="button"
                            className="pixel-modal-close"
                            onClick={onClose}
                            aria-label="Close modal"
                        >
                            ×
                        </button>
                    </div>
                </div>
                <div className="pixel-modal-body">
                      {children}
                      {imageUrl && (
                        <img
                          src={imageUrl}
                          alt={modalTitle || ''}
                          style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto 12px' }}
                        />
                      )}
                      {content}
                    </div>
            </div>
        </div>
    );

    if (typeof document !== 'undefined') {
        return ReactDOM.createPortal(modal, document.body);
    }
    return modal;
});

export { Modal2Component as Modal2 };
export default Modal2Component;
